import React, { useEffect, useState } from 'react';
import hoistoryStore from "../../store/historyStore";
import * as util from "../../utils/util";
import api from "../../utils/api";

import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, List, ListItem, Typography } from "@mui/material";
import Top from "../Top";
import Bottom from "../Bottom";
import Circle from "../../components/CircleProgress";
import BarChart from "../../components/BarChart";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import HistoryFoodInput from "../../components/HistoryFoodInput";
import calendarfood from "../../assets/icon/calendarfood.gif";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetCalory = {
  calory: 0,
  target_calory: 0
}

const HistoryEatFood = () => {
  const storeData: any = hoistoryStore();
  const [targetDate, setTargetDate] = React.useState('');
  const [targetCalory, setTargetCalory] = React.useState(initTargetCalory);
  const [targetMeal, setTargetMeal] = React.useState(
    {
      morning_names: '', morning_calory: '', lunch_names: '', lunch_calory: '',
      dinner_names: '', dinner_calory: '', snack_names: '', snack_calory: ''
    });
  const [series, setSeries] = React.useState([
    { dataKey: 'morning', label: '아침', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
    , { dataKey: 'lunch', label: '점심', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
    , { dataKey: 'dinner', label: '저녁', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
    , { dataKey: 'snack', label: '간식', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
  ]);
  const [dataset, setDataset] = React.useState([{ morning: 0, lunch: 0, dinner: 0, snack: 0, month: '' }]);
  const [dayValue, setDayValue] = useState(0);

  useEffect(() => {
    setCaloryData();
  }, [dayValue]);

  function setCaloryData() {
    // 섭취 칼로리 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_002?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetDate(params.target);
        setTargetCalory(res.data.result_data.target);
        setTargetMeal(res.data.result_data.target.meal);
        setSeries(series);
        const tempArr = getCaloryDataset(res.data.result_data.data);
        setDataset(tempArr.reverse());
        const morningList = res.data.result_data.target.meal.morning.map((v: any) => true ? { ...v, gubun: 'morning', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        const lunchList = res.data.result_data.target.meal.lunch.map((v: any) => true ? { ...v, gubun: 'lunch', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        const dinnerList = res.data.result_data.target.meal.dinner.map((v: any) => true ? { ...v, gubun: 'dinner', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        const snackList = res.data.result_data.target.meal.snack.map((v: any) => true ? { ...v, gubun: 'snack', calory: Number(v.calory) / Number(v.amount), amount: Number(v.amount) } : v);
        storeData.setSelectedFoodList(morningList.concat(lunchList).concat(dinnerList).concat(snackList));
      }
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 섭취 칼로리 바차트 데이터 설정
  function getCaloryDataset(resData: any) {
    let tempArr = [];
    const series = ['morning', 'lunch', 'dinner', 'snack'];
    const monthArr = resData.morning_v2.map((item: any) => item.x);
    let index = 0;

    for (let sr of series) {
      for (let item of resData[sr + '_v2']) {
        index++;
        let obj = { morning: 0, lunch: 0, dinner: 0, snack: 0, month: monthArr[index] };
        if (sr === 'morning') {
          obj.month = item.x;
          // @ts-ignore
          obj[sr] = item.y;
          tempArr.push(obj)
        } else {
          // @ts-ignore
          tempArr.find((v: any) => v.month === item.x)[sr] = item.y;
        }
      }
    }
    return tempArr;
  }

  // 음식 저장
  async function handleComplete(value: any) {
    const series = ['morning', 'lunch', 'dinner', 'snack'];

    for (const sr of series) {
      let saveParams = { date: '', gubun: '', name: '', calory: '', amount: '' };
      saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
      saveParams.gubun = sr;
      saveParams.name = storeData.selectedFoodList.filter((v: any) => v.gubun === sr).map((v: any) => v.name).join('--');
      saveParams.calory = storeData.selectedFoodList.filter((v: any) => v.gubun === sr).map((v: any) => util.strNull(v.calory * v.amount)).join('--');
      saveParams.amount = storeData.selectedFoodList.filter((v: any) => v.gubun === sr).map((v: any) => util.strNull(v.amount)).join('--');

      await api.post(`app/api/v1/AP_002_006`, saveParams).then(res => {
      }).catch(function (error) {
        console.log(error)
      });
    }
    setCaloryData();
    storeData.setSelectedFoodList([]);
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="식사 기록" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setDayValue((prev) => prev - 1)} sx={{ verticalAlign: 'text-bottom' }} />
            {targetDate.slice(0, 4) + '.' + targetDate.slice(4, 6) + '.' + targetDate.slice(6, 8)}
            <ArrowRightIcon onClick={() => setDayValue((prev) => prev + 1)} sx={{ 'display': dayValue < 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Stack direction={'row'} justifyContent={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Grid sx={{
              '& .CircleChart .MuiGauge-root': { width: '130px', height: '130px' },
              '& .CircleChart .circleText': { fontSize: 24, },
            }}>
              <Circle progress={{ goal: targetCalory.target_calory, value: targetCalory.calory }} />
            </Grid>

            <Stack justifyContent={'center'} sx={{ m: 'auto', }}>
              <Avatar alt="" src={calendarfood} sx={{ m: 'auto', width: '60px', height: '60px' }} />
            </Stack>

            <Stack direction={'row'} alignItems={'center'} sx={{ ml: 'auto', mr: 2 }}>
              <Stack direction={'column'} sx={{ ml: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 35, color: '#EF8322', fontWeight: 700 }}>
                  {util.formatComma(Math.round(targetCalory.calory))}
                </Typography>
                <Typography component="span" sx={{ fontSize: 20, color: '#999', mb: 0, textAlign: 'right' }}>
                  {util.formatComma(targetCalory.target_calory)}
                </Typography>
              </Stack>

              <Typography component="div" sx={{ fontSize: 18, color: '#777', ml: 1, mb: 2 }}>
                kcal
              </Typography>
            </Stack>
          </Stack>

          <Accordion defaultExpanded sx={{ borderRadius: '15px', position: 'static' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                '&#panel1a-header': { minHeight: '55px' },
                '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 }
              }}
            >
              <Typography sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>식사 기록</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <List sx={{ p: 0 }}>

                <ListItem>
                  <Grid container alignItems="center">
                    <Grid xs={8}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#555', fontWeight: 700 }}>아침</Typography>
                      <Typography component="div" sx={{ fontSize: 12, color: '#777', }}>{targetMeal.morning_names}</Typography>
                    </Grid>
                    <Grid xs={3}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.morning_calory)}</Typography>
                    </Grid>
                    <Grid xs={1}>
                      <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem>
                  <Grid container alignItems="center">
                    <Grid xs={8}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#555', fontWeight: 700 }}>점심</Typography>
                      <Typography component="div" sx={{ fontSize: 12, color: '#777', }}>{targetMeal.lunch_names}</Typography>
                    </Grid>
                    <Grid xs={3}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.lunch_calory)}</Typography>
                    </Grid>
                    <Grid xs={1}>
                      <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem>
                  <Grid container alignItems="center">
                    <Grid xs={8}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#555', fontWeight: 700 }}>저녁</Typography>
                      <Typography component="div" sx={{ fontSize: 12, color: '#777', }}>{targetMeal.dinner_names}</Typography>
                    </Grid>
                    <Grid xs={3}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.dinner_calory)}</Typography>
                    </Grid>
                    <Grid xs={1}>
                      <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem>
                  <Grid container alignItems="center">
                    <Grid xs={8}>
                      <Typography component="div" sx={{ fontSize: 14, color: '#555', fontWeight: 700 }}>간식</Typography>
                      <Typography component="div" sx={{ fontSize: 12, color: '#777', }}>{targetMeal.snack_names}</Typography>
                    </Grid>
                    <Grid xs={3}>
                      <Typography component="div" sx={{ fontSize: 16, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(targetMeal.snack_calory)}</Typography>
                    </Grid>
                    <Grid xs={1}>
                      <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>Kcal</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>

          <Grid container justifyContent="center" alignItems="center" >
            <HistoryFoodInput handleComplete={handleComplete} />
          </Grid>

          <Box sx={{ bgcolor: '#fff', p: '0 10px 20px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>최근 7일</Typography>
              </Stack>
              <Stack sx={{ ml: 'auto', zIndex: 2 }} >
                <Button sx={{ fontSize: 12, color: '#555', }} endIcon={<ArrowRightIcon />} >
                  월간현황
                </Button>
              </Stack>
            </Stack>
            <Divider />

            <Box sx={{ mt: -3.5 }}>
              <BarChart dataset={dataset}
                chartSetting={chartSet}
                series={series}
              />
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

const chartSet = {
  xAxis: [
    {
      label: '',
    },

  ],
  maxWidth: 450,
  height: 300,
  slotProps: {
    legend: {
      direction: 'row',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: -5,
      itemMarkWidth: 10,
      itemMarkHeight: 10,
      labelStyle: {
        fontSize: 12,
      },
    },
  },
};

export default HistoryEatFood;